<template>
  <div
    class="main"
    data-app="true"
  >
    <v-app class="card">
      <v-container>
        <v-form
          ref="form"
          v-model="isFormValid"
          class="validation-border input-field"
          @submit.prevent="submit"
        >
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <h4 class="card-header">
                Create your NetCredit account.
              </h4>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                id="dm-email-input"
                v-model="form.email"
                :rules="rules.emailCheck"
                label="Email (this will be your username)"
                filled
                hide-details="auto"
                required
                class="email_input input-field"
                validate-on-blur
                @input="clearEmail"
              >
                <template
                  v-if="form.email"
                  v-slot:append
                >
                  <v-icon
                    v-if="!loginError && validEmail()"
                    class="mdi mdi-check"
                  />
                  <v-icon
                    v-else
                    class="mdi mdi-close"
                  />
                </template>
              </v-text-field>
              <p
              v-show="loginError"
              class="submit-error"
              >
                An account has already been created for this email.
                <a href="https://www.netcredit.com/signin" class="link">
                  Please login.</a>
              </p>

            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                id="dm-password-input"
                v-model="form.password"
                :rules="rules.passwordCheck"
                label="Create password"
                filled
                hide-details="auto"
                required
                class="password_input input-field"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                validate-on-blur
                @click:append="showPassword = !showPassword"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              align="center"
              class="one-col-row-mobile"
            >
              <v-btn
                x-large
                class="prev-btn"
                @click="previous"
              >
              </v-btn>
              <v-btn
                x-large
                color="#007EB1"
                class="confirm-btn"
                type="submit"
                :disabled="submitPressed"
              >
                Create Account
              </v-btn>
            </v-col>
          </v-row>

        </v-form>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AccountCreationForm',
  data() {
    return {
      form: {
        email: this.$store.state.directMail.applicationData.email,
        password: this.$store.state.directMail.applicationData.password,
      },

      showPassword: false,
      loginError: false,

      rules: {
        emailCheck: [
          (val) => !!val ||
            'Enter a valid email like name@example.com.',
          (val) => this.validEmail((val || '')) ||
            'Enter a valid email like name@example.com.',
        ],
        passwordCheck: [
          (val) => !!val || 'Enter a password with a minimum of 7 characters.',
          (val) => (val || '').length >= 7 ||
            'Enter a password with a minimum of 7 characters.',
        ],
      },

      isFormValid: false,
      submitPressed: false,
    };
  },
  computed: {
    ...mapGetters([
      'accountCreationErrorMessage',
    ]),
  },
  methods: {
    ...mapActions([
        'createAccount',
      ]),
    validEmail(currentEmail = this.form.email) {
      return (
        /^([^.@\s]+(\.[^.]+)*)@((?:[-a-z0-9]+\.)+[a-z]{2,})/.
        test(currentEmail));
    },
    previous() {
      this.$store.commit('ADD_ACCOUNT_LOGIN_DATA', this.form);
      this.$store.commit('SET_APPLY_CARD', 'address-amount-card');
      window.scrollTo(0,0);
    },
    clearEmail() {
      if (this.loginError) {
        this.loginError = false;
      }
    },
    async submit() {
      if (this.submitPressed) { return };
      this.$refs.form.validate();
      if (this.isFormValid){
        this.submitPressed = true;
        this.$store.commit('ADD_ACCOUNT_LOGIN_DATA', this.form);

        await this.createAccount();

        switch(this.accountCreationErrorMessage) {
          case '':
            window.location.replace(window.location.origin + '/profile_info');
            break;
          case 'duplicate email address':
            this.loginError = true;
            this.submitPressed = false;
            break;
          case 'invalid social security number':
            this.loginError = true;
            this.submitPressed = false;
            break;
          default:
            window.location.replace(window.location.origin);
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">

.card {
  background: #ffffff;
  position: relative;
  @media (max-width: 768px) {
    box-shadow: 0px;
    padding: 15px;
  }

  @media (min-width: 768px) {
    box-shadow: 0px 2px 3px #00000029;
    padding: 40px;
  }
}

.one-col-row-mobile {
  @media (max-width: 450px) {
    font: normal normal bold 16px/25px Open Sans;
    max-width: 100%;
    flex: 100%;
  }
}

.card-header {
  color: #333333;
  font-size: 18px;
  font: normal normal bold 18px/25px Open Sans;
  letter-spacing: 0px;
  opacity: 1;
  align-items: left;
  @media (max-width: 768px) {
    font: normal normal bold 16px/25px Open Sans;
  }
}

.validation-border {
  ::v-deep .v-input__slot {
    border: 1px solid #A9A9A9 !important;
    background: #ffffff !important;
    
    fieldset {
      border: 1px solid #A9A9A9;
      background: #ffffff;
    }

    &:before, &:after {
      display: none;
    }
  }
  ::v-deep .v-input--has-state .v-input__slot{
    border: 1px solid #DB2435 !important;
  }
  ::v-deep .v-text-field__details {
    margin-bottom: 0px;
  }
  ::v-deep .primary--text{
    color: #007EB1 !important;
    caret-color: #333333 !important;
  }
  ::v-deep .error--text{
   color: #DB2435 !important;
   caret-color: #333333 !important;
  }
}

.submit-error {
  font-size: 12px;
  color: #DB2435 !important;
  caret-color: #DB2435 !important;
  text-align: right !important;
  word-break: break-word;
}

::v-deep .v-messages__message {
  text-align: right;
}
.mdi-close:before{
  color: #DB2435;
}
.mdi-check:before {
  color: #4EBB85;
}

.input-field {
  border-radius: 5px;
  opacity: 1;
  color: #A9A9A9;

  font: normal normal normal 16px/28px Open Sans;
  letter-spacing: 0px;

  .corrected .v-label--active {
    top: 10px !important
  }
}

.confirm-btn {
  color: #ffffff;
  border-radius: 5px;
  opacity: 1;
  background: #007eb1;
  border: 2px solid #007eb1;
  ::v-deep .v-btn__content {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: center;
    text-transform: none;
    padding: 0px;
  }
  &:hover,
  &:focus {
    background: #016c98;
    border: 2px solid #016c98;
  }
  &:active {
    box-shadow: 0 0 8px #007eb1;
    background-color: #007eb1 0% 0% no-repeat padding-box;
    border: 2px solid #007eb1;
    color: #ffffff;
  }
  &:disabled {
    background-color: #d7d7d7 0% 0% no-repeat padding-box;
    border: 2px solid #d7d7d7;
    color: #333333 !important;
  }
  @media (max-width: 375px) {
    max-width: 95%;
  }
}

.prev-btn {
  height: 68px;
    min-width: 60px !important;
    background: url('../../../../assets/images/arrow_back_blue.png') no-repeat;
    background-color: #FFFFFF !important;
    background-size: 12px;
    background-position: center;
    border: 2px solid #a9a9a9;
    border-radius: 5px;
    opacity: 1;
    margin-right: 30px;

    @media(max-width: 550px) {
        height: 54px;
        margin-right: 0;
    }

    &:hover,
    &:focus {
        background: url(
          '../../../../assets/images/arrow_back_blue.png') no-repeat;
        background-size: 12px;
        background-position: center;
        opacity: 1;
        border: 2px solid #007EB1;
    }

    &:active, &.active {
        background: image-url(
          '../../../../assets/images/arrow_back_blue.png') no-repeat;
        background-size: 12px;
        background-position: center;
        opacity: 1;
        box-shadow: 0 0 8px #007EB1;
    }
}
</style>
